// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"889":"436b1095","908":"c8cb5e57","990":"66bd6168"}[chunkId] + ".chunk.js";
};